const DEFAULT_OPACITY = 1;

export function isHex(colorCode) {
  return colorCode[0] === '#';
}

export function calculateAlphaFromHex(hexValue) {
  let hexOpacity;
  if (hexValue.length === 5) {
    hexOpacity = hexValue.substring(4).repeat(2);
  } else if (hexValue.length === 9) {
    hexOpacity = hexValue.substring(7);
  }
  return Math.round((parseInt(hexOpacity, 16) / 255) * 100) / 100;
}

export function hexToRgba(hexValue) {
  let r, g, b;
  if (hexValue.length === 4 || hexValue.length === 5) {
    const result = /^#?([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})/i.exec(hexValue);
    r = parseInt(result[1].repeat(2), 16);
    g = parseInt(result[2].repeat(2), 16);
    b = parseInt(result[3].repeat(2), 16);
  } else {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})/i.exec(hexValue);
    r = parseInt(result[1], 16);
    g = parseInt(result[2], 16);
    b = parseInt(result[3], 16);
  }
  return `rgba(${r}, ${g}, ${b}, ${DEFAULT_OPACITY})`;
}

export function rgbToRgba(rgbValue) {
  const [r, g, b] = rgbValue.replace(/[^\d,]/g, '').split(',');
  return `rgba(${r}, ${g}, ${b}, ${DEFAULT_OPACITY})`;
}

export function getRgbaValueWithDefaultAlpha(colorCode) {
  if (colorCode[0] === '#') {
    return hexToRgba(colorCode);
  }
  return rgbToRgba(colorCode);
}

export function getRgbaWithAlpha(rgbaValue, alpha) {
  const [r, g, b] = rgbaValue.replace(/[^\d,]/g, '').split(',');
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function calculateRgbaWithAlpha(colorCode, alpha = DEFAULT_OPACITY) {
  if (colorCode === null || colorCode === undefined || colorCode === '') {
    throw new Error('color is not defined');
  }
  const rgbaValue = getRgbaValueWithDefaultAlpha(colorCode);
  return getRgbaWithAlpha(rgbaValue, alpha);
}
